import axios from "axios"

export async function GetProducts() {

  try {

    const { data } = await axios.get(process.env.REACT_APP_LIST_MERCHANTS,
      {
        headers: {
          Authorization: sessionStorage.getItem("jwt"),
        }
      }
    );

    const body = JSON.parse(data.body);
    const statusCode = data.statusCode;

    if (statusCode !== 200) {
      throw new Error(`Error: ${statusCode}`);
    }

    // console.log({body});

    return {
      data: body
    }

  } catch (error) {

    return {
      error: error?.message ?? 'Error desconocido'
    }

  }

}

export async function GetProductsPercentage({
  products = []
}) {

  try {

    const { data: responseData, status } = await axios.post(process.env.REACT_APP_VALID_EXPORT_ENDPOINT,
      {
        data: products
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("jwt"),
        }
      }
    );

    if (status !== 200) {
      throw new Error(`Error: ${status}`);
    }

    return {
      data: responseData
    }

  } catch (error) {

    return {
      error: error?.message ?? 'Error desconocido'
    }

  }

}

export async function SaveSingleAttribute({
  articleId = 0,
  articleVersion = 0,
  attributeId = 0,
  attributeName = '',
  newValue = ''
}) {

  try {

    const { data } = await axios.put(process.env.REACT_APP_UPDATE_ATTRIBUTE,
      {
        article_id: articleId,
        version_id: articleVersion,
        attribute_id: attributeId,
        new_value: newValue
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("jwt"),
        }
      }
    );

    const body = JSON.parse(data.body);
    const statusCode = data.statusCode;

    if (statusCode !== 200) {
      throw new Error(`Error al guardar el atributo ${attributeName} (${attributeId})`);
    }

    return {
      data: body
    }

  } catch (error) {
    return {
      error: error?.message ?? 'Error desconocido'
    }
  }

}